import React, { FC } from "react";
import { Id, Person } from "../../../types";
import { useMachine } from "@xstate/react";
import { fetchMachine } from "../../../machines/fetch";
import { useRecoilState, useRecoilValue } from "recoil";
import { activeSubscriptionIdState, peopleState } from "../../../atoms";
import { useForm } from "react-hook-form";
import {
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Stack,
  useToast,
} from "@chakra-ui/react";
import { renamePerson } from "../../../api/rename-person";

type FormData = Pick<Person, "name">;

type Props = {
  id: Id;
  onSuccess: () => void;
};

export const RenamePerson: FC<Props> = (props) => {
  const { id, onSuccess } = props;

  const toast = useToast();

  const activeSubscriptionId = useRecoilValue(activeSubscriptionIdState);
  const [people, setPeople] = useRecoilState(peopleState);
  const person = people[id];

  const { register, handleSubmit, errors, watch } = useForm<FormData>({
    defaultValues: { name: person.name },
  });
  const watchName = watch("name");

  const onSubmit = () => {
    send(state.matches("failure") ? "RETRY" : "FETCH");
  };

  const [state, send] = useMachine(fetchMachine, {
    services: {
      fetch: () =>
        renamePerson({
          id,
          name: watchName,
          subscriptionId: activeSubscriptionId as Id,
        }),
    },

    actions: {
      success: (_, event: any) => {
        setPeople(event.data.people);
        onSuccess();
        toast({
          title: "naam van persoon aangepast",
          status: "success",
          isClosable: true,
        });
      },

      failure: (_, event: any) => {
        toast({
          title: "naam van persoon aanpassen niet gelukt",
          description: JSON.stringify(event.data, null, 2),
          status: "error",
          isClosable: true,
        });
      },
    },
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Stack spacing={8} align="start">
        <FormControl isRequired isInvalid={errors.name !== undefined}>
          <FormLabel>naam</FormLabel>
          <Input
            name="name"
            ref={register({
              required: "je hebt geen naam ingevuld",
            })}
          />
          <FormErrorMessage>{errors.name?.message}</FormErrorMessage>
        </FormControl>

        <Button type="submit" size="sm" isLoading={state.matches("loading")}>
          pas aan
        </Button>
      </Stack>
    </form>
  );
};
